export default __webpack_public_path__ + "static/media/trener15.8fb48c00.png";